import { createSlice } from "@reduxjs/toolkit";

const SLICE = "Export";

export interface ExportState {
  isExportAPIFailed: boolean;
  showExportLoader: boolean;
}

const initialState: ExportState = {
  showExportLoader: false,
  isExportAPIFailed: false
};

export const ExportSlice = createSlice({
  name: SLICE,
  initialState,
  reducers: {
    setShowExportLoader: (state, action) => {
      state.showExportLoader = action.payload;
    }
  }
});

export const { setShowExportLoader } = ExportSlice.actions;

export default ExportSlice.reducer;
